import { useState, useRef, useEffect } from "react";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import { MainPaginate } from "../components/app/buttons";
import { ExpertisePill } from "../components/tables/data-table";

const Extractor = ({
	pres,
	setPres,
	processInner,
}: {
	pres: any[];
	setPres: React.Dispatch<React.SetStateAction<any[]>>;
	processInner?: any;
}) => {
	let [file, setFile] = useState(null),
		fileRef: any = useRef();

	let handleChangeImage = (e: React.ChangeEvent<HTMLInputElement>) => {
		const filer = e.target.files[0];
		let err = "";

		if (!filer) return (err = `File, ${filer?.name} does not exist`);

		if (err) {
			return toast.error(err);
		} else {
			setFile(filer);
		}
	};

	useEffect(() => {
		if (file) {
			extractor(file);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [file]);

	const trimObjectKeys = (arr?: any[]) => {
		return arr?.map((obj: any) => {
			return Object.keys(obj).reduce((acc, key) => {
				const trimmedKey = key.trim();
				acc[trimmedKey] =
					typeof obj[key] === "string" ? obj[key]?.trim() : obj[key]; // Add key-value pair with trimmed key
				return acc;
			}, {});
		});
	};

	let extractor = (file: File) => {
		if (file) {
			const reader = new FileReader();
			if (processInner) {
				reader.onload = event => {
					// Type check for FileReader result
					if (event.target?.result instanceof ArrayBuffer) {
						const data = new Uint8Array(event.target.result); // Correct type conversion
						const workbook = XLSX.read(data, { type: "array" });

						// Assuming the data is on the first sheet
						const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
						const jsonData = XLSX.utils.sheet_to_json(firstSheet, {
							defval: "",
						});

						const processedData = processData(jsonData);
						setPres(processedData);
						console.log(processedData);
					} else {
						console.error("File data is not an ArrayBuffer.");
					}
				};

				reader.readAsArrayBuffer(file);
			} else {
				// var name = file.name;
				reader.onload = evt => {
					// evt = on_file_select event
					/* Parse data */
					const bstr = evt.target.result;
					const wb = XLSX.read(bstr, { type: "binary" });
					/* Get first worksheet */
					const wsname = wb.SheetNames[0];
					const ws = wb.Sheets[wsname];
					/* Convert array of arrays */
					const data: Array<Array<any>> = XLSX.utils.sheet_to_json(ws, {
						header: processInner ? 1 : 2,
					});
					console.log({ data });

					if (processInner) {
						let result = processData(data);
						console.log({ result });
						setPres(result);
					} else setPres(trimObjectKeys(data));
				};
				reader.readAsBinaryString(file);
			}
		}
	};

	// Helper function to trim all keys and values in an object
	const trimObject = (obj: {
		[key: string]: string;
	}): { [key: string]: string } => {
		const trimmedObj: { [key: string]: string } = {};
		Object.keys(obj).forEach(key => {
			const trimmedKey = key.trim();
			const trimmedValue =
				typeof obj[key] === "string" ? obj[key].trim() : obj[key];
			trimmedObj[trimmedKey] = trimmedValue;
		});
		return trimmedObj;
	};

	const processData = (data: any[]) => {
		let groupedData: any = {};

		data.forEach(row => {
			const trimmedRow = trimObject(row); // Trim all keys and values in each row

			Object.keys(trimmedRow).forEach(key => {
				let match = key.match(/\[(.*?)\]/); // Extract text inside square brackets
				let cleanKey = key.replace(/\[.*?\]/, "").trim(); // Remove square brackets and trim the key

				if (match) {
					let category = match[1]; // Category name inside square brackets
					if (!groupedData[category]) {
						groupedData[category] = {};
					}
					if (trimmedRow[key]) {
						// Group similar keys
						if (!groupedData[category][cleanKey]) {
							groupedData[category][cleanKey] = [];
						}
						groupedData[category][cleanKey].push(trimmedRow[key]);
					}
				} else {
					// Handle keys without square brackets
					if (!groupedData["No Category"]) {
						groupedData["No Category"] = {};
					}
					if (trimmedRow[key]) {
						if (!groupedData["No Category"][cleanKey]) {
							groupedData["No Category"][cleanKey] = [];
						}
						groupedData["No Category"][cleanKey].push(trimmedRow[key]);
					}
				}
			});
		});

		// Convert grouped data into final structure
		return Object.keys(groupedData).map(category => ({
			category: category,
			data: Object.keys(groupedData[category]).map(key => ({
				category: key,
				data: groupedData[category][key],
			})),
		}));
	};

	// const processSheetData = (sheetData: Array<Array<any>>) => {
	// 	const result: Array<any> = [];

	// 	// Ensure that sheetData[0] is an array for the headers
	// 	let headers = Array.isArray(sheetData[0])
	// 			? sheetData[0]
	// 			: Object.keys(sheetData[0]),
	// 		lastValidValue = "";
	// 	console.log({ headers1: headers });

	// 	// Assign default headers if any headers are empty
	// 	headers = headers.map((header, index) => {
	// 		if (
	// 			header === undefined ||
	// 			header === "" ||
	// 			header?.includes("__EMPTY_")
	// 		) {
	// 			header = lastValidValue;
	// 			// header = `${lastValidValue || ""}Column${index + 1}`;
	// 		} else {
	// 			lastValidValue = header; // Update last valid value if current is not empty
	// 		}
	// 		return header; // Return the last valid value (or current value if not empty)
	// 	});
	// 	// headers.map((header, index) =>
	// 	// 			header === undefined || header === "" ? `Column${index + 1}` : header
	// 	// 		);
	// 	console.log({ headers });

	// 	sheetData.forEach((row, rowIndex) => {
	// 		// Ensure row is an array, if not, convert it to an array
	// 		let rowArray = Array.isArray(row) ? row : Object.values(row);
	// 		// Assign default headers if any headers are empty
	// 		// rowArray = rowArray.map((header, index) => {
	// 		// 	if (
	// 		// 		header === undefined ||
	// 		// 		header === "" ||
	// 		// 		header?.includes("__EMPTY_")
	// 		// 	) {
	// 		// 		header = lastValidValue;
	// 		// 		// header = `${lastValidValue || ""}Column${index + 1}`;
	// 		// 	} else {
	// 		// 		lastValidValue = header; // Update last valid value if current is not empty
	// 		// 	}
	// 		// 	return header; // Return the last valid value (or current value if not empty)
	// 		// });
	// 		headers = rowArray;
	// 		console.log({ row, rowArray });

	// 		// If the row is completely empty, skip it
	// 		if (rowArray.every(cell => cell === undefined || cell === "")) return;

	// 		// Find the first non-empty value in the row (starting from the first non-empty cell)
	// 		const firstNonEmptyIndex = rowArray.findIndex(
	// 			cell => cell !== undefined && cell !== ""
	// 		);

	// 		const newRow = rowArray.map((cell, colIndex) => {
	// 			// If the cell is empty:
	// 			// - Fill it with the preceding value from the same row
	// 			// - Skip if the row started with empty values (i.e., firstNonEmptyIndex > colIndex)
	// 			return cell !== undefined && cell !== ""
	// 				? cell
	// 				: colIndex > firstNonEmptyIndex
	// 				? rowArray[firstNonEmptyIndex]
	// 				: "";
	// 		});

	// 		// Create an object using the first row as the header
	// 		const rowObject: { [key: string]: any } = {};
	// 		headers.forEach((header, colIndex) => {
	// 			rowObject[header] = newRow[colIndex];
	// 		});

	// 		// Only push row data after the first (header) row
	// 		if (rowIndex > 0) result.push(rowObject);
	// 	});

	// 	return result;
	// };

	let [range] = useState(9);

	const [itemOffset, setItemOffset] = useState(0);
	const endOffset = itemOffset + range;

	const currentItems = pres?.slice(itemOffset, endOffset);
	const pageCount = Math.ceil(pres?.length / range);

	const handlePageClick = event => {
		const newOffset = (event.selected * range) % pres?.length;
		setItemOffset(newOffset);
		// setPage(1 + event?.selected);
	};

	return (
		<>
			<div
				onClick={() => fileRef?.current?.click()}
				className={`rounded-lg ${
					file && pres?.length > 0
						? "overflow-auto h-[400px] border border-dashed border-gray-300 bg-grey py-10"
						: ""
				}`}>
				{file && pres?.length > 0 ? (
					<>
						{!processInner && (
							<table className="w-full text-sm text-left text-gray-500 overflow-auto">
								<thead className="text-md text-gray-700 capitalize bg-secondary">
									<tr>
										{Object?.keys(pres?.[0])?.map((it, i) => (
											<th key={i} scope="col" className="px-6 py-3">
												{it}
											</th>
										))}
									</tr>
								</thead>
								<tbody>
									{currentItems?.map((organization, ind) => (
										<tr
											key={ind}
											className="bg-white border-b hover:bg-gray-50">
											{Object?.keys(pres?.[0])?.map((it, i) => (
												<td key={i} className="px-6 py-4">
													{organization?.[it]}
												</td>
											))}
										</tr>
									))}
								</tbody>
							</table>
						)}
						{processInner && (
							<>
								{currentItems?.map((item: any, index: number) => (
									<div className="w-full text-gray-500  grid gap-5" key={index}>
										<div className="py-2 text-black">{item?.category}</div>
										<div className="">
											{item?.data?.map((it: any, ind: number) => (
												<div className="grid grid-cols-3 gap-3 py-2" key={ind}>
													<div className="">{it?.category}</div>
													<div className=" col-span-2">
														<div className="flex gap-1 max-w-xl overflow-x-auto pb-2">
															{it?.data?.map((ic: string, i: number) => (
																<ExpertisePill value={ic} key={i} />
															))}
														</div>
													</div>
												</div>
											))}
										</div>
									</div>
								))}
							</>
						)}
						{/* {processInner && <pre>{JSON.stringify(pres, null, 2)}</pre>} */}
					</>
				) : (
					<div className="w-full cursor-pointer h-56 bg-[#F7F7F7] rounded-lg flex justify-center items-center">
						<div>
							<img
								src={require("../assets/icons/document.svg")}
								alt=""
								className="mx-auto"
							/>
							<h6 className="text-center text-[#1b1b1b] font-medium text-base">
								{"Select a CSV file to upload"}
							</h6>
							<p className="text-base font-normal text-[#718096] text-center">
								or drag and drop it here
							</p>
						</div>
					</div>
				)}
				<input
					ref={fileRef}
					type="file"
					style={{ width: "0" }}
					className="absolute -z-10"
					onChange={handleChangeImage}
					accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,.csv"
				/>
			</div>
			{pageCount > 1 && (
				<MainPaginate pageCount={pageCount} handlePageClick={handlePageClick} />
			)}
		</>
	);
};

export default Extractor;

export const toCamel = (o: any) => {
	var newO: any, origKey: any, newKey: any, value: any;
	if (o instanceof Array) {
		return o.map(function (value) {
			if (typeof value === "object") {
				value = toCamel(value);
			}
			return value;
		});
	} else {
		newO = {};
		for (origKey in o) {
			if (o.hasOwnProperty(origKey)) {
				newKey = (
					origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey
				).toString();
				newKey = newKey
					?.split(" ")
					?.map((it, i) => {
						let newIt =
							i === 0
								? (it.charAt(0).toLowerCase() + it.slice(1) || it).toString()
								: (it.charAt(0).toUpperCase() + it.slice(1) || it).toString();
						return newIt;
					})
					?.join("");
				value = o[origKey];
				if (
					value instanceof Array ||
					(value !== null && value.constructor === Object)
				) {
					value = toCamel(value);
				}
				newO[newKey] = typeof value === "string" ? value?.trim() : value;
			}
		}
	}
	return newO;
};

export const StringTOCamel = (origKey: any) => {
	let checkKey = (
		origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey
	).toString();
	checkKey = checkKey
		?.split(" ")
		?.map((it: any, i: number) => {
			let newIt =
				i === 0
					? (it.charAt(0).toLowerCase() + it.slice(1) || it).toString()
					: (it.charAt(0).toUpperCase() + it.slice(1) || it).toString();
			return newIt;
		})
		?.join("");

	return checkKey;
};

export const combineArray = (o: any, escape?: any) => {
	var newO: any,
		origKey: any,
		newKey: any,
		value: any,
		checkKey: any,
		rawData: any[] = [];
	if (o instanceof Array) {
		return o.map(function (value) {
			if (typeof value === "object") {
				value = combineArray(value, escape);
			}
			return value;
		});
	} else {
		newO = {};
		for (origKey in o) {
			if (o.hasOwnProperty(origKey)) {
				newKey = origKey.toString();
				// newKey = newKey?.split(" ")?.join("");
				value = o[origKey];
				checkKey = (
					origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey
				).toString();
				checkKey = checkKey
					?.split(" ")
					?.map((it, i) => {
						let newIt =
							i === 0
								? (it.charAt(0).toLowerCase() + it.slice(1) || it).toString()
								: (it.charAt(0).toUpperCase() + it.slice(1) || it).toString();
						return newIt;
					})
					?.join("");
				if (
					value instanceof Array ||
					(value !== null && value?.constructor === Object)
				) {
					value = combineArray(value, escape);
				}
				if (escape && escape?.includes(checkKey)) {
					newO[newKey] = typeof value === "string" ? value?.trim() : value;
				} else {
					let nextD = [],
						// eslint-disable-next-line @typescript-eslint/no-unused-vars
						newData =
							typeof value === "string"
								? value
										?.trim()
										?.split("\r\n")
										?.map(ix => ix?.trim())
										?.map(iq =>
											nextD?.push(...iq?.split(",")?.map(pc => pc?.trim()))
										)
								: null;

					rawData?.push({
						category: newKey,
						data: typeof value === "string" ? nextD : value,
					});
				}
			}
		}
		if (escape) newO.rawData = rawData;
		else newO = rawData;
		rawData = [];
	}
	return newO;
};

export const ProgressBarSocket = ({ progress, current }) => {
	return (
		<>
			<div className="w-[96%] bg-[#F1F8FF] rounded-full min-h-1 text-center">
				<div
					className={`w-[${progress}%] bg-[#3787FF] rounded-full h-2 text-center text-white`}
					style={{
						width: progress ? `${progress}%` : "",
					}}></div>
			</div>
			<span className="text-black block text-center">
				{current} {progress}%
			</span>
		</>
	);
};
